<template>
<div class="main">

<div class="container">
    <div class="wrapper">
    <h3>Tak for din bestilling af engangsfuldmagt til levering af pakker med GLS. </h3>
<br>
    <p>Venlig hilsen</p>
    <img  alt="gls"  src="../assets/Mini_logo.png" height="25" width="100"/>
    </div>
</div>

</div>
</template>

<script>
    export default {
        name: "Complete"
    }
</script>
<style lang="scss" scoped>
    #app {
        font-family: "thesansplain", Verdana, sans-serif;
    }
    .container{
        max-width: 800px;
        display: flex;
        flex-direction: column;
        .topimage{
            width:100%;
            height:auto;

        }
    }
    .wrapper{
        padding:10px;
        flex-direction: column;
        @media screen and(min-width:800px) {
            display: flex;
            justify-content: center;
            border: 1px solid #d6d6d6;
            padding: 38px;
            box-shadow: #d6d6d6 0px 0px 30px
        }
    }
    .main {
        max-width: 800px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .image-holder{
            width:800px;
            @media screen and (max-width: 800px) {
                width:100%;
                margin-top: 5px !important;
                margin-bottom: 5px !important;
            }
        }

        .logo {
            max-width: 200px;

            display: flex;
            flex-direction: column;
            @media screen and(max-width: 800px){
                flex-direction: row;
            }
            button{
                align-self: center;
                margin-top:auto;
                @media screen and(max-width: 800px){
                    display:none;
                }
            }

            img {
                width: 100%;
            }
            @media screen and (max-width: 1080px) {
                max-width: 600/19.2 * 1vw;
            }
            @media screen and (max-width: 800px) {
                display: flex;
                justify-content: center;
                width: 100%;
                max-width: 100%;
                img {
                    width: 50%;
                }
            }
        }
    }
</style>
